import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Container, Form, Modal, Row, Spinner} from "react-bootstrap";
import {Api} from "./Api.tsx";
import queryString from 'query-string';


const client = new Api();

function App() {
  const [users, setUsers] = useState<Array<string>>([]);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [failureMessage, setFailureMessage] = useState<string>("");
  const parsed = queryString.parse(location.search);

  useEffect(() => {
    client.getUsers().then(users => setUsers(users));
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <h4>iForm Uploader</h4>
          <hr/>
        </Row>
        <Row className="justify-content-md-center mb-3">
          <Col sm={10}>
            <ProjectUploadForm
              code={parsed.code as string}
              users={users}
              onSuccess={setSuccessMessage}
              onFailure={setFailureMessage}
            />
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col sm={10}>
            {
              successMessage && <Alert variant={"success"}>{successMessage}</Alert>
            }
            {
              failureMessage && <Alert variant={"danger"}>{failureMessage}</Alert>
            }
          </Col>
        </Row>
      </Container>
    </>
  )
}

const ProjectUploadForm = (props: FormProps) => {
  const initialFormState = {
    projectCode: props.code ? props.code : "",
    selectedUsers: [],
    submitting: false,
    progress: 0,
    step: FormStep.Initial
  };
  const [formState, setFormState] = useState<FormState>(initialFormState);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const {options} = event.target;
    const selectedUsers = [];

    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedUsers.push(options[i].value);
      }
    }

    setFormState({...formState, selectedUsers});
  };


  const handleSubmit = () => {

    const {projectCode, selectedUsers} = formState;

    switch (formState.step) {
      case FormStep.Initial:
        setFormState({...formState, submitting: true});
        client
          .getAssignmentDetail({inspectionId: projectCode})
          .then(response => {

            const assignedUsers = response.map(r => r.username)

            setFormState({...formState, step: FormStep.InspectionSubmission, submitting: false, selectedUsers: assignedUsers});

          })
          .catch(() => setFormState({...formState, step: FormStep.InspectionSubmission, submitting: false}));
        break;
      case FormStep.InspectionSubmission:
        setFormState({...formState, submitting: true});
        client
          .createInspection({inspectionId: projectCode, users: selectedUsers})
          .then(async response => {
            if (response.ok) {
              return response.text();
            } else {
              throw await response.text();
            }
          })
          .then(successMessage => props.onSuccess(successMessage))
          .catch(errorMessage => props.onFailure(errorMessage))
          .finally(() => setFormState(initialFormState))
        break;
    }
  }

  if (formState.submitting) {
    return <LoadingModal/>
  }

  return (
    <Form className="p-4" style={{background: "#f2f2f2"}}>
      <Row className="mb-3">
        <Col>
          <Form.Control
            placeholder="Project Code or Milestone Id"
            value={formState.projectCode}
            onChange={e => setFormState({...formState, projectCode: e.target.value})}
          />
        </Col>
      </Row>

      {
        formState.step === FormStep.InspectionSubmission &&
        <Row className="mb-3">
          <Col>
            <Form.Label>User Assignment</Form.Label>
            <Form.Select
              multiple
              size="lg"
              htmlSize={12}
              value={formState.selectedUsers}
              onChange={handleSelectChange}>
              {
                props.users.map(user => <option key={user}>{user}</option>)
              }
            </Form.Select>
          </Col>
          <Col>
            <Form.Label>Selected Users</Form.Label>
            <ul className="list-group">
              {
                formState.selectedUsers.map(selectedUser => (
                  <li key={selectedUser} className="list-group-item" onClick={() => {
                    const selected = formState.selectedUsers.filter(user => user !== selectedUser);
                    setFormState({...formState, selectedUsers: selected})
                  }}>
                    {selectedUser}
                  </li>
                ))
              }
            </ul>
          </Col>
        </Row>
      }


      {
        !formState.submitting &&
        <Row>
          <Col>
            {
              formState.step == FormStep.Initial &&
              (
                <Button variant="primary" type="button" onClick={handleSubmit}>
                  Next {' >'}
                </Button>
              )
            }
            {
              (formState.step == FormStep.InspectionSubmission) &&
              (
                <Button variant="primary" type="button" onClick={handleSubmit}>
                  Submit
                </Button>
              )
            }
          </Col>
        </Row>
      }
    </Form>
  )
}

const LoadingModal = () => {
  return (
    <Modal show={true}>
      <Modal.Body>
        <Modal.Header className={"mb-3"}>Uploading...</Modal.Header>
        <div className="text-center">
          <Spinner animation="border" role="status" style={{width: "4rem", height: "4rem"}}/>
        </div>
      </Modal.Body>
    </Modal>
  )
}

enum FormStep {
  Initial,
  InspectionSubmission
}

type FormState = {
  projectCode: string;
  selectedUsers: Array<string>;
  submitting: boolean;
  progress: number;
  step: FormStep
}

type FormProps = {
  code: string;
  onSuccess: (message: string) => void;
  onFailure: (message: string) => void;
  users: Array<string>;
}

export default App